import { combineReducers, configureStore, StateFromReducersMapObject } from "@reduxjs/toolkit";
import reducers from './reducers';
import { loadState, saveState } from "./persistent/localStorage";
import Logger from "@utils/logger";
import { omit, throttle } from "lodash";
import { initializeAuthWith } from "@infobis/as-react-auth";
import { AuthSelector } from "../routes";
// определяем корневой редьюсер.
const rootReducer = combineReducers(reducers)
const preloadedState = loadState()
const log = Logger.getLogger("store")
log.debug("Preloaded state", preloadedState)

export const store = initializeAuthWith(configureStore({
    devTools: true,
    reducer: rootReducer,
    middleware:(getDefaultMiddleware) => {
        return getDefaultMiddleware({ thunk: true, serializableCheck: false })
    },
    preloadedState,
    enhancers: (existingEnhancers) => {
        // Add the autobatch enhancer to the store setup
        return existingEnhancers({
            autoBatch: {
                type: 'callback',
                queueNotification: (notify) => {
                    let fn = notify as { (): void; throttled: () => void }
                    fn.throttled = fn.throttled || throttle(() => {
                        log.debug("Run store notification...")
                        notify()
                    }, 1000, { leading: false })
                    fn.throttled()
                }
            }
        })
    }
}), AuthSelector)

store.subscribe(throttle(() => {
    const state = store.getState()
    saveState({
        // @ts-ignore
        auth: omit(state.auth, ['isApiLoading']),
        mapTabSettings: state.mapTabSettings,
        geoZoneTabSettings: state.geoZoneTabSettings,
        markersTabSettings: state.markersTabSettings
    })
}, 1000))

// типизируем, в дальнейшем будем использовать хук useTypedSelector, чтобы получать типизированные фрагменты store.
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch;
export type RootThunkAPI = {
    getState: () => RootState;
    dispatch: AppDispatch;
};
